import { Source, SourcesResponse } from './types';

const SOURCES: Source[] = [
  {
    platform: 'google',
    externalAccountId: '3749249422',
    label: 'Enrico Personal',
    lastSyncAt: '2026-05-31T03:12:47.000Z',
    currency: 'EUR',
    timezone: 'Europe/Rome',
  },
  {
    platform: 'meta',
    externalAccountId: 'act_2487200801724671',
    label: 'Polimo Ads',
    lastSyncAt: '2026-05-31T03:13:02.000Z',
    access: 'Owned',
    currency: 'EUR',
    timezone: 'Europe/Rome',
  },
];

export const SOURCES_MOCK: SourcesResponse = { sources: SOURCES };

export const DEFAULT_GOOGLE_IDS = SOURCES.filter((s) => s.platform === 'google').map((s) => s.externalAccountId);

export const DEFAULT_META_IDS = SOURCES.filter((s) => s.platform === 'meta').map((s) => s.externalAccountId);
